import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useReplaceTokenWithElement } from '../../../../../hooks';
import { MLP_IMAGE_URL } from '../constants';
import pmStyles from '../PMKitWidget.scss';
import { getImageUrlPM } from '../../../../../utils';

const EquipmentImageWithDescription = ({
  isMachineLandingPage,
  selectedEquipment,
  selectedSerial,
  serialNumber,
  isPmKitsLoadedSuccessfully,
  salesModel
}) => {
  const [t] = useTranslation();
  const { replaceTokenWithElement } = useReplaceTokenWithElement();
  const className = 'exclude-global color-dark-gray text-md';
  const pmKitText = replaceTokenWithElement(
    isPmKitsLoadedSuccessfully ? t('PM_KIT_WIDGET_ALT1') : t('PM_KIT_UI3'),
    className,
    <strong className="fw-bold">{salesModel}</strong>,
    <strong className="fw-bold text-capitalize">
      {selectedEquipment?.equipmentFamily?.toLowerCase()}
    </strong>
  );
  const pmKitModelText = replaceTokenWithElement(
    t('PM_KIT_UI3'),
    className,
    <strong className="fw-bold">{salesModel}</strong>,
    <strong className="fw-bold text-capitalize">
      {selectedEquipment?.equipmentFamily?.toLowerCase()}
    </strong>
  );
  const nonSerialNumberText = isPmKitsLoadedSuccessfully
    ? `${t('PM_KIT_Serial1')}`
    : `${t('PM_KIT_MODEL3')}`;
  const serialNumberText = isPmKitsLoadedSuccessfully
    ? `${t('PM_KIT_Serial1')}`
    : '';
  const widgetText = (
    <p>
      {pmKitText}
      &nbsp;
      {serialNumber ? serialNumberText : nonSerialNumberText}
    </p>
  );

  const modelTextOnly = (
    <p>
      {pmKitModelText}
      &nbsp;
      {t('PM_KIT_MODEL3')}
    </p>
  );
  const imageUrlPM = getImageUrlPM(selectedEquipment.imageURL);
  return (
    <div className="d-flex align-items-center">
      <div className={`${pmStyles['pmkit-image__box']}`}>
        {isMachineLandingPage ? (
          <img
            src={MLP_IMAGE_URL}
            alt={MLP_IMAGE_URL}
            width="55"
            height="140"
          />
        ) : (
          <img src={imageUrlPM} alt={selectedEquipment.equipmentFamily} />
        )}
      </div>
      {selectedSerial || serialNumber ? widgetText : modelTextOnly}
    </div>
  );
};

EquipmentImageWithDescription.propTypes = {
  isMachineLandingPage: PropTypes.bool,
  selectedEquipment: PropTypes.shape({
    equipmentFamily: PropTypes.string,
    imageURL: PropTypes.string
  }),
  selectedSerial: PropTypes.shape({
    displayValue: PropTypes.string,
    value: PropTypes.number
  }),
  serialNumber: PropTypes.string,
  isPmKitsLoadedSuccessfully: PropTypes.bool,
  salesModel: PropTypes.string
};

export default EquipmentImageWithDescription;
